import React, { useState, useEffect } from "react";
import GenericButton from "../../components/Custom/GenericButton";
import { Box, Container, Card, Avatar, Typography } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import api from "../../globals/axios";
import { useNavigate } from "react-router-dom";

const AgroExpertMain = () => {
  const { t } = useTranslation();
  const [view, setView] = useState("new");
  const [unansweredQuestions, setUnansweredQuestions] = useState([]);
  const [answeredQuestions, setAnsweredQuestions] = useState([]);
  const navigate = useNavigate();

  const MAX_QUESTION_LENGTH = 32;

  useEffect(() => {
    fetchUnansweredQuestions();
    fetchAnsweredQuestions();
  }, []);

  const fetchUnansweredQuestions = async () => {
    try {
      const response = await api.get("/advisory/unanswered-questions/");
      setUnansweredQuestions(response.data);
    } catch (error) {
      console.error("Error fetching unanswered questions:", error);
    }
  };

  const fetchAnsweredQuestions = async () => {
    try {
      const response = await api.get("/advisory/answers/answered_by_advisor/");
      console.log(response.data);
      setAnsweredQuestions(response.data);
    } catch (error) {
      console.error("Error fetching answered questions:", error);
    }
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Box
          display="flex"
          justifyContent="space-between"
          mt={2}
          sx={{
            backgroundColor: "white",
            padding: "0 10px",
            border: "1px solid #A5A5A5",
            borderRadius: "4px",
          }}
        >
          <Box flex="1" mr={1}>
            <GenericButton
              onClick={() => setView("new")}
              backgroundColor={view === "new" ? "#4CAF50" : "white"}
              fontColor={view === "new" ? "white" : "black"}
              borderColor={view === "new" ? "#388E3C" : "#A5A5A5"}
              padding="8px 20px"
              fontSize="14px"
              hideIcon
            >
              {t("new")}
            </GenericButton>
          </Box>
          <Box flex="1" ml={1}>
            <GenericButton
              onClick={() => setView("answered")}
              backgroundColor={view === "answered" ? "#4CAF50" : "white"}
              fontColor={view === "answered" ? "white" : "black"}
              borderColor={view === "answered" ? "#388E3C" : "#A5A5A5"}
              padding="8px 20px"
              fontSize="14px"
              hideIcon
            >
              {t("Answered")}
            </GenericButton>
          </Box>
        </Box>
        <Box mt={2}>
          {view === "new" ? (
            <>
              {unansweredQuestions.length > 0 ? (
                unansweredQuestions.map((question) => (
                  <Card
                    key={question.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      padding: "10px",
                      borderRadius: "4px",
                      boxShadow: "1px 2px 4px 0px #86828240",
                      marginBottom: "10px",
                    }}
                    onClick={() => navigate(`/unanswered/${question.id}`)}
                  >
                    <Avatar
                      src="path/to/your/image.jpg"
                      sx={{ width: 50, height: 50, marginRight: "10px" }}
                    />
                    <Box sx={{ padding: "10px 0" }}>
                      <Typography variant="body1">
                        {question.asked_by.full_name}
                      </Typography>
                      <Typography variant="body1">
                        {question.text_en.length > MAX_QUESTION_LENGTH
                          ? `${question.text_en.slice(
                              0,
                              MAX_QUESTION_LENGTH
                            )}...`
                          : question.text_en}
                      </Typography>
                    </Box>
                  </Card>
                ))
              ) : (
                <p>{t("No unanswered questions available.")}</p>
              )}
            </>
          ) : (
            <>
              {answeredQuestions.length > 0 ? (
                answeredQuestions.map((question) => (
                  <Card
                    key={question.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      padding: "10px",
                      borderRadius: "4px",
                      boxShadow: "1px 2px 4px 0px #86828240",
                      marginBottom: "10px",
                    }}
                    onClick={() => navigate(`/answered/${question.id}`)}
                  >
                    <Avatar
                      src="path/to/your/image.jpg"
                      sx={{ width: 50, height: 50, marginRight: "10px" }}
                    />
                    <Box sx={{ padding: "10px 0" }}>
                      <Typography variant="body1">
                        {question.question.asked_by.full_name}
                      </Typography>
                      <Typography variant="body1">
                        {question.question.text_en.length > MAX_QUESTION_LENGTH
                          ? `${question.question.text_en.slice(
                              0,
                              MAX_QUESTION_LENGTH
                            )}...`
                          : question.question.text_en}
                      </Typography>
                    </Box>
                  </Card>
                ))
              ) : (
                <p>{t("No answered questions available.")}</p>
              )}
            </>
          )}
        </Box>
      </Container>
    </>
  );
};

export default AgroExpertMain;
